<template>
  <div class="custom-select" :tabIndex="tabIndex" @blur="isOpen = false" @click=click()>
    <div v-show="selected.promptPackName !== null" class="selected" :class="{ 'open': isOpen }" @click="isOpen = !isOpen">
      {{ selected.promptPackName }}
    </div>
    <div v-show="selected.promptPackName === null" class="selected">
      {{ noOptionsText }}
    </div>
    <div class="items" :class="{ 'closed': !isOpen || disabled }">
      <div
        class="item"
        v-for="(option, index) of options"
        :key="index"
        @click="select(option)"
      >
        {{ option.promptPackName }}
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'PromptPackCustomSelect',
  props: {
    options: {
      type: Array,
      required: true
    },
    default: {
      type: Object,
      required: false,
      default: null
    },
    noOptionsText: {
      type: String,
      required: false,
      default: 'No Options'
    },
    tabIndex: {
      type: Number,
      required: false,
      default: 0
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      selected: this.default ? this.default : (this.options.length > 0 ? this.options[0]: null),
      isOpen: false,
    };
  },
  methods: {
    select(option) {
      this.selected = option;
      this.isOpen = false;
      this.$emit('input', option);
    },
    click() {
      this.$emit('click');
    }
  },
  mounted() {
    this.$emit("input", this.selected);
  },
})
</script>

<style scoped lang="scss">
.custom-select {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  line-height: 1.8em;
  height: 100%;
  padding: 0.14em 0;
  font-size: 1.2em;

  .selected {
    display: block;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: white;
    border-radius: 0.4em;
    border: 0.1em solid #d3d3d3;
    color: black;
    padding: 0.4em 0;
    padding-left: 1em;
    padding-right:2em;
    cursor: pointer;
    user-select: none;

    white-space: nowrap; 
    overflow-x: hidden;
    text-overflow: ellipsis; 

    &:after {
      position: absolute;
      content: '';
      top: 45%;
      right: 1em;
      width: 0;
      height: 0;
      border: 5px solid transparent;
      border-color: black transparent transparent transparent;
    }
    &.open {
      border-color: black;
    }
    &.open:after {
      border-color: $brand-teal transparent transparent transparent;
    }
    &:hover {
      border-color: black;
    }
    &:hover:after {
      position: absolute;
      content: '';
      top: 45%;
      right: 1em;
      width: 0;
      height: 0;
      border: 5px solid transparent;
      border-color: $brand-teal transparent transparent transparent;
    }
  }
  .items {
    color: black;
    border-radius: 0px 0px 6px 6px;
    overflow-y: auto;
    max-height: 12em;
    border-right: 1px solid black;
    border-left: 1px solid black;
    border-bottom: 1px solid black;
    position: absolute;
    background-color: white;
    left: 0;
    right: 0;
    z-index: 100;

    div {
      color: black;
      padding-left: 1em;
      cursor: pointer;
      user-select: none;
      &:hover {
        background-color: $lilac-purple;
        color: white;
      }
    }
  }
  .item {
    padding: 0.4em 0;
    padding-right: 2em;
    white-space: nowrap; 
    overflow-x: hidden;
    text-overflow: ellipsis; 
  }
}

.closed {
  display: none;
}

</style>
